<template>
  <div>
    <div class="xin">
      <div class="left2">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          menu-trigger="click"
         
        >
       
          <el-submenu index="1">
            <template slot="title">
            
              内容过滤</template>
            <el-menu-item index="1">添加过滤规则</el-menu-item>
          </el-submenu>
        
          <el-submenu index="2" class="top-11">
            <template slot="title"><router-link to="/home/antiSpam/globalStrategy/2" tag="li">  IP白名单</router-link></template>
            <el-menu-item index="2-1" class="top-01">增加IP白名单</el-menu-item>
            <el-menu-item index="2-1" class="top-01">导入IP白名单</el-menu-item>
            <el-menu-item index="2-1" class="top-01">导出IP白名单</el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">IP黑名单</template>
            <el-menu-item index="3-1" class="top-01">增加IP黑名单</el-menu-item>
            <el-menu-item index="3-1" class="top-01">导入IP黑名单</el-menu-item>
            <el-menu-item index="3-1" class="top-01">导出IP黑名单</el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">From白名单</template>
            <el-menu-item index="4-1" class="top-01">增加发件人白名单</el-menu-item>
            <el-menu-item index="4-1" class="top-01">导入发件人白名单</el-menu-item>
            <el-menu-item index="4-1" class="top-01">导出发件人白名单</el-menu-item>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">From黑名单</template>
            <el-menu-item index="5-1" class="top-01">增加发件人黑名单</el-menu-item>
            <el-menu-item index="5-1" class="top-01">导入发件人黑名单</el-menu-item>
            <el-menu-item index="5-1" class="top-01">导出发件人黑名单</el-menu-item>
          </el-submenu>
          <el-submenu index="6">
            <template slot="title">URL黑名单</template>
            <el-menu-item index="6-1" class="top-01">添加URL黑名单</el-menu-item>
          </el-submenu>
          <el-submenu index="7">
            <template slot="title">URL白名单</template>
            <el-menu-item index="7-1" class="top-01">添加URL白名单</el-menu-item>
          </el-submenu>
          <el-submenu index="8">
            <template slot="title">内容白名单</template>
            <el-menu-item index="8-1" class="top-01">添加内容白名单</el-menu-item>
          </el-submenu>
          <el-submenu index="9">
            <template slot="title">防伪名字列表</template>
            <el-menu-item index="9-1" class="top-01">上传防伪列表</el-menu-item>
            <el-menu-item index="9-1" class="top-01">增加防伪名字</el-menu-item>
            <el-menu-item index="9-1" class="top-01">设置防伪提示</el-menu-item>
          </el-submenu>
<el-submenu index="10">
            <template slot="title">收件人黑名单</template>
           <el-menu-item index="9-1" class="top-01">增加收件人黑名单</el-menu-item>
            <el-menu-item index="9-1" class="top-01">导入收件人黑名单</el-menu-item>
            <el-menu-item index="9-1" class="top-01">导出收件人黑名单</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>

      <div class="xuan">
        <div class="pop-up" v-show="tanchu">
          <div class="find">
            <div class="find1">
              <div class="find-text">
                <span style="margin-right:4px"></span> 类型:
              </div>
              <div class="block">
                <el-select v-model="value" class="selece1">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="find1">
              <div class="find-text" style="padding-right:12px">
                <span style="margin:0 42px"></span> 分数:
              </div>
              <div class="block block1">
                <el-input
                  v-model="input"
                  placeholder="累计分数达到50，邮件拒收"
                ></el-input>
              </div>
            </div>
            <div class="find1">
              <div class="find-text" style="padding-right:12px">
                正则表达式过滤规则:
              </div>
              <div class="block block1">
                <el-input v-model="input"></el-input>
              </div>
            </div>
            <div class="find1">
              <div class="find-text">
                <span style="margin-right:-20px"></span> 策略类型:
              </div>
              <div class="block">
                <el-select v-model="value" class="selece1">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <el-row>
            <el-button type="primary" @click="tanSend()">保存</el-button>
            <el-button type="primary" @click="tanOff()">取消</el-button>
          </el-row>
        </div>
        <div class="gray" v-show="tanchu"></div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",

      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],

      options: [
        {
          value: "选项1",
          label: "不使用TLS",
        },
        {
          value: "选项2",
          label: "增加信头标记",
        },
        {
          value: "选项3",
          label: "强制TLS",
        },
      ],
      checked: "",

      tanchu: false,
      activeIndex: "1",
      show: false,
    };
  },
  mounted() {
    $(".left2 ul").on("click", function() {
      //获取索引值
      var index = $(this).index();
      console.log(index);
      console.log(1111);

      // $(".tabCla div").eq(index).show().siblings().hide()
    });
    
  },
  beforeRouteUpdate(to, from, next) {
    

    next();
  },
  methods: {
    // 显示
    tan: function() {
      this.tanchu = true;
    },
    // 打开关闭
    tanSend: function() {
      this.tanchu = false;
    },
    tanOff: function() {
      this.tanchu = false;
    },
    // 数据
  },
};
</script>
<style lang="less" scoped>

/deep/ .is-opened {
  background: chartreuse;
}
.top-01{
  width: 100px;
}.top-11{
  min-width: 100px;
}
.xin {
  display: flex;
  flex-direction: column;
}
.left2 {
  display: flex;
height: 30px;
  box-sizing: border-box;
}
.xin /deep/.el-menu-item {
  min-width: 100px !important;
  height: 30px;
  line-height: 30px;
  box-sizing: border-box;
}

 /deep/.el-menu.el-menu--horizontal:nth-last-child(1) {
  border-right: none;
}
.xuan {
  background: #eee;
}

// 弹框
// 弹出框1
// 一行
.find {
  display: flex;
  flex-direction: column;
  text-align: left;
  background: #f1f1f1;
  border: 1px solid #dcdfe6;
  margin-top: 10px;
  padding: 40px 0;
  width: 80%;
  p {
    color: #999;
    font-size: 12px;
    text-align: center;
  }
}
.find1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2px 0;
}
// 文字
.find-text {
  padding: 0 20px;
  font-size: 12px;
}

.el-input {
  // width: 20%;
  padding: 5px 10px 5px 0;
}

/deep/ .el-select {
  // padding-left: 30px;
  width: 222px;
}
// button  按钮
/deep/ .el-button {
  padding: 6px 10px;
  margin-left: 10px;
  margin: 5px 20px;
  font-size: 12px;
}

.pop-up {
  position: fixed;
  padding: 20px 0;
  width: 50%;
  top: 10%;
  left: 25%;
  z-index: 101;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  //   margin-left: -12.5%;
  //   margin-top: -14%;
}

.gray {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: black;
  opacity: 0.6;
  z-index: 100;
}
</style>
